export default "__VITE_ASSET__E6_bUWyp__"